/* import __COLOCATED_TEMPLATE__ from './create-check.hbs'; */
import Component from '@glimmer/component';
export default class CreatePrintableCheck extends Component {
  get showCheckEducation() {
    return this.args.showCheckEducation ||
    // If nothing passed in is true, return true
    !this.args.showCheckEducation && !this.args.showWriteACheck && !this.args.showCheckSuccess && !this.args.showCheckError;
  }
}